export default __webpack_public_path__ + "d60ac75fc49f3a44049f3852b76afabe.svg";